export const UNIT_TEST = {
  ComponentCreated: 'ComponentCreated',
  dataValidation: {
    DataValidation_NullUsername: 'DataValidation_NullUsername_Error',
    DataValidation_NullPassword: 'DataValidation_NullPassword_Error',
    DataValidation_NullUsernamePassword:
      'DataValidation_NullUsernamePassword_Error',
    DataValidation_ValidCredentials: 'DataValidation_ValidCredentials_NoError',
    DataValidation_Null_Company: 'DataValidation_NullCompany_Error',
    DataFormat_InvalidCompanyName: 'DataValidation_InvalidCompanyName_Error',
    DataValidation_SameMobileLandline:
      'DataValidation_SameMobileLandline_Error',
    DataFormat_InvalidMobileNo: 'DataFormat_InvalidMobileNo_Error',
    DataFormat_InvalidLandline: 'DataFormat_InvalidLandlineNo_Error',
    DataFormat_InvalidEmail: 'DataFormat_InvalidEmail_Error',
    DataFormat_InvalidZipCode:
      'DataFormat_InvalidZipCodeFormat(zipcode = l6mom3)_CorrectZipCode',
    DataValidation_NullPartName: 'DataValidation_NullPartName_Error',
    DataValidation_NullPartCost: 'DataValidation_NullPartCost_Error',
    DataValidation_NullPartPrice: 'DataValidation_NulPartPrice_Error',
    DataValidation_NullPartPricingTitle:
      'DataValidation_NullPartPricingTitle_Error',
    DataValidation_NullPricingItems:
      'DataValidation_NullPartPricingItems_Error',
    DataValidation_NullVehicleCustomer:
      'DataValidation_NullVehicleCustomer_Error',
    DataValidation_NullVehicle: 'DataValidation_NullVehicle_Error',
    DataValidation_InvalidPartPricings:
      'DataValidation_InvalidPartPricings_Error',
    DataValidation_ValidPartPricing: 'DataValidation_ValidPartPricing_NoError',
    DataValidation_InvalidPartPricingRage:
      'DataValidation_InvalidPartPricingRange_Error',
    DataValidation_ZeroEstimateValue: 'DataValidation_ZeroEstimateValue_Error',
    DataVaidation_NullEstimate: 'DataValidation_NullEstimate_Error',
    DataValidation_InvalidAmount: 'DataValidation_InvalidPaymentAmount_Error',
    DataValidation_NullPaymentMethod:
      'DataValidation_InvalidPaymentMethod_Error',
    DataValidation_ValidPaymentCredentials:
      'DataValidation_ValidCredentials_NoError',
    DataValidation_NullServiceTitle: 'DataValidation_NullServiceTitle_Error',
    DataValidation_NullServiceItemTitle:
      'DataValidation_NullServiceItemTitle_Error',
    DataValidation_ZeroServiceItemCount:
      'DataValidation_ZeroServiceItemCount_Error',
    DataValidation_NullServiceItemPrice:
      'DataValidation_NullServiceItemPrice_Error',
    DataValidation_InvalidTimeRange: 'DataValidation_InvalidTimeRange_Error',
    DataValidation_NullCommunicationPrefences:
      'DataValidation_NullCommunicationPrefences_Error',
    DataValidation_NullInspectionItemName:
      'DataValidation_NullInspectionItemName_Error',
    DataValidation_InvalidTaxValue: 'DataValidation_InvalidTaxValue_Error',
    DataValidation_NullCompanyName: 'DataValidation_NullCompanyName_Error',
    DataValidation_NullCompanyEmail: 'DataValidation_NullCompanyEmail_Error',
    DataValidation_NullCompanyWebsite:
      'DataValidation_NullCompanyWebsite_Error',
    DataValidation_NullCompanyPhone: 'DataValidation_NullCompanyPhone_Error',
    DataValidation_NullCompanyZip: 'DataValidation_NullCompanyZip_Error',
    DataValidation_InvalidEmail: 'DataValidation_InvalidEmail_Error',
    DataValidation_NullUserFirstName: 'DataValidation_NullUserFirstName_Error',
    DataValidation_NullUserLastName: 'DataValidation_NullUserLastName_Error',
    DataValidation_NullEmail: 'DataValidation_NullEmail_Error',
    DataValidation_NullPhone: 'DataValidation_NullPhone_Error',
    DataValidation_InvalidPhone: 'DataValidation_InvalidPhone_Error',
    DataValidation_NullCustomerFirstName:
      'DataValidation_NullCustomerFirstName_Error',
    DataValidation_NullCannedServiceItemType:
      'DataValidation_NullCannedServiceItemType_Error',
  },
  calculation: {
    ValidCostWithPricingTemplate:
      'Calculation_ValidCostWithPricingTemplate_Calculated',
    NullCostPriceWithPricingTemplate:
      'Calculation_NullCostPriceWithPricingTemplate_Error',
    Calculation_CalculateTotalOnImportService:
      'Calculation_CalculateTotalOnImportService_Calculated',
    Calculation_EstimatePaidToDate: 'Calculation_EstimatePaidToDate_Calculated',
    Calculation_DiscountValue: 'Calculation_DiscountValue_Calculated',
    Calculation_MarkupCalculation: 'Calculation_MarkupCalculation_Calculated',
    Calculation_CannedServiceTotal: 'Calculation_CannedServiceTotal_Calculated',
  },
  execution: {
    Execution_DeleteCannedInspection:
      'Execution_DeleteCannedInspection_Executed',
    Execution_SetCategoryOnClick: 'Execution_SetCategoryOnClick_Executed',
    Execution_SetCustomerOnSelect: 'Execution_SetCustomerOnSelect_Executed',
    Execution_LogActivityOnImportService:
      'Execution_LogActivityOnImportService_Executed',
    Execution_LogActivityOnDeleteService:
      'Execution_LogActivityOnDeleteService_Executed',
    Execution_DeleteServiceUpdateEstimate:
      'Execution_DeleteServiceUpdateEstimate_Executed',
    Execution_EstimateCalculationWithValidData:
      'Execution_EstimateCalculationWithValidData_Executed',
    Execution_NumerRoundingOff: 'Execution_DataRoundingOff_Executed',
    Execution_FilterKanbanOnTags: 'Execution_FilterKanbanOnTags_Executed',
    Execution_FilterKanbanOnTechs: 'Execution_FilterKanbanOnTechs_Executed',
    Execution_FilterKanbanOnAuthorization:
      'Execution_FilterKanbanOnAuthorization_Executed',
    Execution_AppointmentWithValidData:
      'Execution_AppointmentWithValidData_Executed',
    Execution_CalenderNavigaitonOnTechSelect:
      'Execution_CalenderNavigaitonOnTechSelect_Executed',
  },
  formatting: {
    Formatting_CustomerList: 'Formatting_CustomerList_Formatted',
    Formatting_CannedServicesList: 'Formatting_CannedServicesList_Formatted',
    Formatting_PartsList: 'Formatting_PartsList_Formatted',
    Formatting_EstimateList: 'Formatting_EstimateList_Formatted',
    Formatting_PaymentsList: 'Formatting_PaymentsList_Formatted',
  },
};
